import React, { useRef } from 'react';
import styled, { keyframes } from 'styled-components';
import { card, FlexColumn } from '@ubeya/shared-web/components';
import useOnClickOutside from '@ubeya/shared-web/hooks/useOnClickOutside';
import usePortal from '@ubeya/shared-web/hooks/usePortal';
import SwapSideBarTable from './SwapSideBarTable';

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(19, 21, 41, 0.3);
  z-index: 5;
`;

const jumpIn = keyframes`
  0%{transform: translateX(100%);}
  100%{transform: translateX(0);}
`;

const Container = styled(FlexColumn)`
  ${card}
  position:fixed;
  bottom: 0;
  width: 100%;
  height: 420px;
  border-radius: 8px 0 0 8px;
  animation: ${jumpIn} 300ms;
`;

const SwapSideBar = ({ data, onClose, onApprove, onDecline }) => {
  const ref = useRef();
  const { Portal } = usePortal({ enabled: true, portalId: 'modal' });
  useOnClickOutside(ref, () => {
    onClose();
  });

  return (
    <Portal>
      <Wrapper>
        <Container>
          <SwapSideBarTable data={data} onClose={onClose} onApprove={onApprove} onDecline={onDecline} />
        </Container>
      </Wrapper>
    </Portal>
  );
};

export default SwapSideBar;
